var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{attrs:{"id":"home-back-bar","app":"","color":"primary","elevation":"1","height":"50"}},[_c('span',{staticClass:"cursor white--text",on:{"click":_vm.Back}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-chevron-left")]),_vm._v("KEMBALI")],1),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }